import React from 'react';
import { contactInfo } from '../data/mock';
import { MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-heading">Mavrexx Innovations</h3>
            <p className="footer-text">
              Precision 3D printing and industrial manufacturing solutions for the modern engineer.
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-subheading">Contact Information</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <Phone className="contact-icon" />
                <span>{contactInfo.phone}</span>
              </div>
              <div className="contact-item">
                <Mail className="contact-icon" />
                <span>{contactInfo.email}</span>
              </div>
            </div>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-subheading address-heading">{contactInfo.address.name}</h4>
            <div className="footer-address">
              <MapPin className="contact-icon address-icon" />
              <div className="address-text">
                <p>{contactInfo.address.line1}</p>
                <p>{contactInfo.address.line2}</p>
                <p>{contactInfo.address.line3}</p>
                <p>{contactInfo.address.city}</p>
                <p>{contactInfo.address.state}</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <p className="footer-copyright">
            © {new Date().getFullYear()} Mavrexx Innovations. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
